<ui-object-navigation-main-page alias="am"></ui-object-navigation-main-page>